import { render, staticRenderFns } from "./TiPixItau.vue?vue&type=template&id=4c5ce72a&scoped=true"
import script from "./TiPixItau.vue?vue&type=script&lang=js"
export * from "./TiPixItau.vue?vue&type=script&lang=js"
import style0 from "./TiPixItau.vue?vue&type=style&index=0&id=4c5ce72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ce72a",
  null
  
)

export default component.exports